import type { FC } from 'react';
import useModal from '~/components/modal/Modal';
import { Button } from '~/components/shared';
import type { Channel } from '~/models/ChannelModel';
import styles from './ChannelPreviewDialog.module.css';

interface Props {
  channels: Channel[];
}

export const ChannelPreviewDialog: FC<Props> = ({ channels }) => {
  const { close } = useModal();
  const ottChannels = channels.filter((c) => c.isOtt);
  const dttChannels = channels.filter((c) => !c.isOtt);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Oversikt over alle valgfrie TV-kanaler</h3>

      <section className={styles.group}>
        <p className={styles.groupTitle}>Kanaler kun over internett</p>
        {/* This should be a list for better accessibility */}
        <ul className={styles.channelsGrid}>
          {/* List item should render similar to a card with logo and name */}
          {ottChannels.map((channel) => (
            <li key={channel.channelId} className={styles.channelTile}>
              <div className={styles.channelLogoContainer}>

                {channel.logoImageUrl ? (
                  <img src={channel.logoImageUrl} alt={channel.name} className={styles.channelLogo} />
                ) : (
                  <div className={styles.logoFallback} aria-hidden="true">
                    {channel.name.slice(0, 2).toUpperCase()}
                  </div>
                )}
              </div>
              <p className={styles.channelName}>{channel.name}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.group}>
        <p className={styles.groupTitle}>Kanaler via antenne og over internett</p>
        <ul className={styles.channelsGrid}>
          {dttChannels.map((channel) => (
            <li key={channel.channelId} className={styles.channelTile}>
              <div className={styles.channelLogoContainer}>
                {channel.logoImageUrl ? (
                  <img src={channel.logoImageUrl} alt={channel.name} className={styles.channelLogo} />
                ) : (
                  <div className={styles.logoFallback} aria-hidden="true">
                    {channel.name.slice(0, 2).toUpperCase()}
                  </div>
                )}
              </div>
              <p className={styles.channelName}>{channel.name}</p>
            </li>
          ))}
        </ul>
      </section>

      <div className={styles.footer}>
        <Button type="secondary" onClick={close}>
          Lukk
        </Button>
      </div>
    </div>
  );
};
